import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import EditPartnerForm from 'components/Admin/Partner/EditPartnerForm';
import actions from 'actions';
import constants from 'constants';
import validator from 'services/validator';
import inputFormatter from 'services/userInputFormatter';
import _ from 'lodash';

const {
  UPDATE_PARTNER_SAGA
} = constants;

const {
  updatePartnerSaga,
  cleanErrors,
  loadPartnerSaga,
  cleanPartner
} = actions;

class EditPartner extends Component {
  static propTypes = {
    createPartner: PropTypes.func,
    cleanErrors: PropTypes.func,
    dispatch: PropTypes.func,
    errors: PropTypes.obj,
    errorsFrontend: PropTypes.obj
  };

  constructor(props) {
    super(props);
    this.state = {
      partner: {
        title: '',
        logo: '',
        namespace: ''
      }
    }
  }

  componentWillReceiveProps(props) {
    if (!_.isEqual(this.props.partner, props.partner))
      this.setState({
        partner: {
          ...this.state.partner,
          ...props.partner
        }
      });
  }

  componentWillMount() {
    this.props.cleanErrors();
    this.props.loadPartner(this.props.params.id)
  }

  componentWillUnmount() {
    this.props.cleanPartners();
  }

  onFieldChange = (e) => {
    const input = inputFormatter.formatField(e.target.name, e.target.value);
    const partnerData = {
      ...this.state.partner,
      ...{
        [e.target.name]: input
      }
    }

    this.setState({ partner: partnerData });
  }

  onSubmit = () => {
    this.props.updatePartner(this.state.partner)
  }

  render() {
    const {
      errors,
      errorsFrontend
    } = this.props;
    return (
      <main className="site--width clearfix-c">
        <EditPartnerForm
          onFieldChange={this.onFieldChange}
          partner={this.state.partner}
          onSubmit={this.onSubmit}
          errors={validator.formatErrors(errors, errorsFrontend)}
        />
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    errors: state.errors[UPDATE_PARTNER_SAGA],
    errorsFrontend: state.errors[`${UPDATE_PARTNER_SAGA}_FRONTEND`],
    partner: state.partners.admin.tmp
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updatePartner: (partner) => dispatch(updatePartnerSaga(partner)),
    cleanErrors: () => dispatch(cleanErrors(UPDATE_PARTNER_SAGA)),
    loadPartner: (id) => dispatch(loadPartnerSaga(id)),
    dispatch: dispatch,
    cleanPartners: () => dispatch(cleanPartner())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditPartner);



// WEBPACK FOOTER //
// ./src/containers/Admin/Partner/EditPartner.jsx